// extracted by mini-css-extract-plugin
export var bodySections = "_bk-8";
export var gray = "_bk-7";
export var green = "_bk-4";
export var iconContainer = "_bk-9";
export var iconWidgetContainer = "_bk-1";
export var phoneIcon = "_bk-2";
export var red = "_bk-5";
export var statusDot = "_bk-3";
export var widgetContainer = "_bk-0";
export var yellow = "_bk-6";